import React, { useState } from 'react';
import * as XLSX from 'xlsx';

// 1. Se define el componente Loader con sus estilos
const Loader = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  }}>
    <div style={{
      border: '8px solid #f3f3f3',
      borderTop: '8px solid #3498db',
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      animation: 'spin 1s linear infinite'
    }}></div>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);


const ExcelUploader = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Por favor, selecciona un archivo primero.');
      return;
    }

    setIsLoading(true);

    try {
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          const sheetName = 'Empleados';
          const sheet = workbook.Sheets[sheetName];

          if (!sheet) {
            alert(`No se encontró la hoja "${sheetName}" en el archivo Excel.`);
            setIsLoading(false);
            return;
          }

          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

          if (rows.length <= 1) {
            alert('El archivo Excel no contiene datos de empleados.');
            setIsLoading(false);
            return;
          }

          for (let i = 1; i < rows.length; i++) {
            const [nombre, apellido, cargo, dni] = rows[i];
            
            if (nombre && apellido && cargo && dni) {
              const bodyData = { nombre, apellido, cargo, dni };

              console.log('Enviando empleado:', bodyData);

              await fetch('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/agregarempleado', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyData),
              });
            }
          }

          alert('Datos de empleados cargados exitosamente.');
        } catch (error) {
          console.error('Error al procesar el archivo Excel:', error);
          alert('Error al procesar el archivo Excel. Revisa la consola para más detalles.');
        } finally {
          setIsLoading(false);
        }
      };

      reader.onerror = () => {
        console.error('Error al leer el archivo.');
        alert('Ocurrió un error al leer el archivo.');
        setIsLoading(false);
      };

      reader.readAsArrayBuffer(selectedFile);
    } catch (error) {
      console.error('Error al iniciar la carga del archivo:', error);
      alert('Error al iniciar la carga del archivo.');
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* 2. Se muestra el Loader cuando isLoading es true */}
      {isLoading && <Loader />}
      
      <h2>Cargar archivo con empleados</h2>
      <input type="file" onChange={handleFileChange} accept=".xlsx, .xls" />
      <button onClick={handleUpload} disabled={isLoading}>
        {isLoading ? 'Cargando...' : 'Cargar Empleados'}
      </button>
    </div>
  );
};

export default ExcelUploader;